import distanceAwayMobileAvif from './variantImages/explore/explore-mobile.avif';
import distanceAwayMobileWebp from './variantImages/explore/explore-mobile.webp';
import distanceAwayMobile from './variantImages/explore/explore-mobile.png';
import distanceAwayAvif from './variantImages/explore/explore.avif';
import distanceAwayWebp from './variantImages/explore/explore.webp';
import distanceAway from './variantImages/explore/explore.png';

import downloadMapsMobileAvif from './variantImages/download/download-mobile.avif';
import downloadMapsMobileWebp from './variantImages/download/download-mobile.webp';
import downloadMapsMobile from './variantImages/download/download-mobile.png';
import downloadMapsAvif from './variantImages/download/download.avif';
import downloadMapsWebp from './variantImages/download/download.webp';
import downloadMaps from './variantImages/download/download.png';

import offRouteMobileAvif from './variantImages/alerts/alerts-mobile.avif';
import offRouteMobileWebp from './variantImages/alerts/alerts-mobile.webp';
import offRouteMobile from './variantImages/alerts/alerts-mobile.png';
import offRouteAvif from './variantImages/alerts/alerts.avif';
import offRouteWebp from './variantImages/alerts/alerts.webp';
import offRoute from './variantImages/alerts/alerts.png';

const distanceAwayImages = {
  mobile: {
    avif: distanceAwayMobileAvif,
    webp: distanceAwayMobileWebp,
    png: distanceAwayMobile
  },
  desktop: {
    avif: distanceAwayAvif,
    webp: distanceAwayWebp,
    png: distanceAway
  }
};

const downloadMapsImages = {
  mobile: {
    avif: downloadMapsMobileAvif,
    webp: downloadMapsMobileWebp,
    png: downloadMapsMobile
  },
  desktop: {
    avif: downloadMapsAvif,
    webp: downloadMapsWebp,
    png: downloadMaps
  }
};

const offRouteAlertImages = {
  mobile: {
    avif: offRouteMobileAvif,
    webp: offRouteMobileWebp,
    png: offRouteMobile
  },
  desktop: {
    avif: offRouteAvif,
    webp: offRouteWebp,
    png: offRoute
  }
};

export default { distanceAwayImages, downloadMapsImages, offRouteAlertImages };
